<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="screen_div">
			<el-input class="input" v-model="screen.supplier_name" clearable placeholder="供应商名称" />
			<el-input class="input" v-model="screen.supplier_cates" clearable placeholder="类目关键词" />
			<el-date-picker class="picker" v-model="screen.created_time" type="datetimerange" clearable
				value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
				placeholder="创建时间范围" />
			<el-select class="select" v-model="screen.state" clearable placeholder="状态">
				<el-option v-for="item in stateList" :key="item.code" :label="item.message" :value="item.code" />
			</el-select>
			<el-button @click="getSupplierList()">筛选</el-button>
			<el-button type="primary" @click="open(-1)">+新增</el-button>
		</div>
		<div class="from_div">
			<el-table class="table_div" v-loading="loading"
				:data="tableData"
				:header-cell-style="tabStyle">
				<el-table-column label="排序" type="index" width="80" align="center" />
				<el-table-column label="供应商信息" min-width="80">
					<template slot-scope="scope">
						<div class="row">
							<img class="logo_img" :src="scope.row.supplier_logo != '' ? scope.row.supplier_logo : img" />
							<div class="col" style="margin-left: 20px;">
								<span>名称：{{ scope.row.supplier_name }}</span>
								<span>编号：{{scope.row.supplier_id}}</span>
								<span>创建：{{scope.row.supplier_expire}}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="主营类目">
					<template slot-scope="scope">
						<span>{{scope.row.supplier_cates}}</span>
					</template>
				</el-table-column>
				<el-table-column label="业务汇总">
					<template slot-scope="scope">
						<div class="col">
							<span>业务订单：{{scope.row.supplier_orders}}</span>
							<span>订单总额：{{scope.row.supplier_amounts}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="audit_text" label="审批" align="center" width="180"/>
				<el-table-column prop="state_text" label="状态" align="center" width="180"/>
				<el-table-column label="操作" width="180">
					<template slot-scope="scope">
						<el-button class="item_btn" size="mini" type="primary"
							@click="open(scope.row.supplier_id)">详情</el-button>
						<el-button class="item_btn" size="mini" type="danger"
							@click="del(scope.row.supplier_id)">删除</el-button>
						<el-button class="item_btn" size="mini" type="success">提审</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!--弹出层-->
		<Popup :name="name" :type="supplier_id" :show="show" @close='close' />
		<div class="foot_div">
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="screen.page" :pageSize="screen.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import Popup from "../../../components/Popup/Popup.vue"
	import {
		delTip
	} from "../../../../src/common/store/util.js"
	import {
		supplierLists,
		supplierDel
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			Popup
		},
		data() {
			return {
				input: '',
				tip: '供应商档案信息维护列表。',
				img: 'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png',
				supplier_id: -1,
				stateList: [], //账户状态列表
				screen: {
					supplier_name: '', //供应商名称
					supplier_cates: '', //类目关键词
					created_time: '', //创建时间范围
					audit: '', //审核状态
					state: '', //状态
					page: 1, //当前页 刷新后默认显示第一页
					limit: 10, //每一页显示的数据量 此处每页显示10条数据
				},
                loading: false,
				tableData: [],
				total: 0,
				name: '',
				show: false
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
			this.getSupplierList();
		},
		methods: {

			//获取供应商列表
			getSupplierList() {
                this.loading = true;
				supplierLists({
					...this.screen
				}).then(res => {
                    this.loading = false;
					if (res.code == 0) {
						this.total = res.count
						res.data.forEach(item => {
							item.audit_text = item.audit_text == '' ? '/' : item.audit_text
						})
						this.tableData = res.data
						this.stateList = res.other.state
					}else{
                        return this.$message.error(res.msg);
                    }
				}).catch(err => {})
			},

			//点击按钮切换页面
			handleCurrentChange(page) {
				this.screen.page = page; //每次点击分页按钮，当前页发生变化
				this.getSupplierList();
			},

			//删除操作
			del(supplier_id) {
				delTip(this, '此操作将永久删除该供应商, 是否继续?', '提示').then(res => {
					if (res == 0) {
						supplierDel({
							supplier_id: supplier_id
						}).then(res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.page = 1;
								this.getSupplierList();
							}
						}).catch(err => {})
					}
				})
			},

			open(supplier_id) {
				this.supplier_id = supplier_id;
				this.name = 'supplierDetail';
				this.show = true
			},

			close(type) {
				if (type == 0) {
					this.page = 1;
					this.getSupplierList();
				}
				this.show = false
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		padding: 20px 20px 0 20px;
		min-height: -webkit-fill-available;
	}

	.row {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.col {
		display: flex;
		flex-direction: column;
	}
	
	.logo_img{
		width: 60px;
		height: 60px;
		border-radius: 100%;
		border: 1px solid #f5f5f5;
		background: #fff;
	}

	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-top: 20px;
	}

	.input {
		width: 185px;
		margin-right: 13px;
	}

	.select {
		width: 128px;
		margin-right: 13px;
	}

	.picker {
		margin-right: 13px;
	}

	.el-button--mini {
		margin-right: 10px;
	}

	.item_btn {
		margin: 0 5px 0 0;
	}

	/*伪类样式*/
	.item_btn:nth-child(3) {
		margin-top: 5px;
	}
	
	.from_div {
		width: 100%;
		height: 600px;
		max-height: 100%;
		overflow: scroll;
		margin-top: 20px;
	}

	.table_div {
		width: 100%;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}

	.pagination {
		display: flex;
		justify-content: right;
		padding: 20px 30px 20px 30px
	}
</style>